import DragHandleIcon from '@mui/icons-material/DragHandle';
import {
  Box, alpha,
  styled,
} from '@mui/material';
import React from 'react';
import * as Space from 'react-spaces';
// eslint-disable-next-line import/no-unresolved
import { IResizeHandleProps } from 'react-spaces/dist/core-react';
import { spaceCadet } from '../utils/colors';

const StyledBox = styled(Space.ViewPort)(() => ({
  // MISC styles
  '& ::-webkit-scrollbar': {
    width: 10,
  },

  '& ::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },

  '& ::-webkit-scrollbar-thumb': {
    background: spaceCadet[300],
    borderRadius: 10,
    '&:hover': {
      background: alpha(spaceCadet[400], 0.6),
    },
  },

  '.spaces-space .spaces-space-inner': {
    display: 'flex',
    flexDirection: 'column',
  },
}));
export default StyledBox;

const StyledResizeHandle = styled((props: IResizeHandleProps) => <Box {...props}><DragHandleIcon /></Box>)(({ className, theme }) => ({
  display: 'flex',
  zIndex: theme.zIndex.appBar + 1,
  '& svg': {
    color: spaceCadet[400],
    fontSize: 20,
    display: 'block',
    ...(className === 'spaces-resize-handle resize-left' && {
      cursor: 'w-resize',
      transform: 'rotate(90deg)',
      marginLeft: -6,
      marginTop: 'auto',
      marginBottom: 'auto',
    }),
    ...(className === 'spaces-resize-handle resize-top' && {
      cursor: 'n-resize',
      marginTop: -4,
      marginLeft: 'auto',
      marginRight: 'auto',
    }),
  },
}));

export function renderStyledHandler(handleProps: IResizeHandleProps): React.ReactNode {
  return <StyledResizeHandle {...handleProps} />;
}
